/* 27 Oct (Claude): shows a star rating line under the product title, using the rating Vitals already puts on the page (no second source, so it always matches). Does nothing if a product has no reviews. Undo: remove the sww-rating line in snippets/meta-tags.liquid. */
(function () {
  'use strict';
  if (window.__swwRating) return;
  window.__swwRating = 1;

  function read() {
    var s = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < s.length; i++) {
      var t = s[i].textContent || '';
      if (t.indexOf('aggregateRating') < 0) continue;
      var v = t.match(/"ratingValue"\s*:\s*"?([0-9.]+)/);
      var c = t.match(/"(?:reviewCount|ratingCount)"\s*:\s*"?([0-9]+)/);
      if (v && c) return { v: parseFloat(v[1]), c: parseInt(c[1], 10) };
    }
    return null;
  }

  function findReviews() {
    var els = document.querySelectorAll('button, a, div, span, h2, h3');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.children.length === 0 && /^\s*write a review\s*$/i.test(e.textContent || '')) {
        var up = e, n = 0;
        while (up.parentElement && n < 6 && up.getBoundingClientRect().height < 250) { up = up.parentElement; n++; }
        return up;
      }
    }
    return null;
  }

  function build(r) {
    var price = document.querySelector('.product__price');
    if (!price) return false;
    if (document.querySelector('.sww-rating')) return true;
    var a = document.createElement('a');
    a.className = 'sww-rating';
    a.href = '#';
    a.setAttribute('aria-label', r.v.toFixed(1) + ' out of 5 stars, ' + r.c + ' reviews. Read the reviews');
    var st = document.createElement('span');
    st.className = 'sww-stars';
    st.setAttribute('aria-hidden', 'true');
    st.textContent = '★★★★★';
    st.style.setProperty('--p', Math.max(0, Math.min(100, r.v / 5 * 100)) + '%');
    var tx = document.createElement('span');
    tx.className = 'sww-rating-text';
    tx.textContent = r.v.toFixed(1) + ' (' + r.c + ' review' + (r.c === 1 ? '' : 's') + ')';
    a.appendChild(st);
    a.appendChild(tx);
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var t = findReviews();
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 130, behavior: 'smooth' });
    });
    price.parentNode.insertBefore(a, price);
    return true;
  }

  function go() {
    var r = read();
    if (r && r.c > 0 && r.v > 0) return build(r);
    return false;
  }

  function start() {
    try { if (go()) return; } catch (e) { return; }
    var n = 0;
    var iv = setInterval(function () {
      n++;
      var ok = false;
      try { ok = go(); } catch (e) { ok = true; }
      if (ok || n > 40) clearInterval(iv);
    }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
